import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickTimeWindowsState = createSelector(
  getOneClickState,
  state => state.timeWindowsState,
);

export const getOneClickTimeWindows = createSelector(
  getOneClickTimeWindowsState,
  state => state.timeWindowsAvailable,
);

export const getOneClickTimeWindowsSelected = createSelector(
  getOneClickTimeWindowsState,
  state => state.selected,
);
